import React, {useContext, useEffect, useState} from "react";
import {BlurredBackdropModal} from "../BlurredBackdropModal/BlurredBackdropModal";
import {Box, Button, Typography} from "@mui/material";
import {css} from "@linaria/core";
import {IosShare, MoreVert, SwapHorizOutlined} from "@mui/icons-material";
import {CustomLink} from "../CustomLink/CustomLink";
import CloseIcon from "@mui/icons-material/Close";
import {Trans, useTranslation} from "react-i18next";
import {isMobile, isAndroid, isIOS, isSafari, isChrome, isFirefox, browserName, isTablet} from "mobile-device-detect";
import {PwaContext} from "./PwaContext";

enum Platforms {
    android,
    androidFirefox,
    ios,
    other
};

export const InstallPwaModal = () => {
    const {t} = useTranslation();
    const {deferredPrompt, setDeferredPrompt} = useContext(PwaContext);
    const [open, setOpen] = useState(false);
    const [platform, setPlatform] = useState<Platforms>();
    const [isStandalone, setIsStandalone] = useState(false);

    useEffect(() => {
        if (!isMobile && !isTablet) return;

        // @ts-ignore
        if (window.navigator.standalone === true || window.matchMedia("(display-mode: standalone)").matches) {
            setIsStandalone(true);
        } else {
            setIsStandalone(false);
        }

        if (isAndroid) {
            if (isFirefox) {
                setPlatform(Platforms.androidFirefox);
            } else {
                setPlatform(Platforms.android);
            }
        } else if (isIOS) {
            setPlatform(Platforms.ios);
        } else {
            setPlatform(Platforms.other);
        }
    }, []);

    const handleOpen = () => {
        setOpen(true);
    }

    const handleClose = () => {
        setOpen(false);
    }

    const handleInstall = async () => {
        if (deferredPrompt) {
            // Trigger the beforeinstallprompt event to give the player the option to install the PWA
            deferredPrompt.prompt();
            const { outcome } = await deferredPrompt.userChoice;

            // The deferredPrompt can only be used once.
            setDeferredPrompt(null);
            
            handleClose();
        }
    }

    if (isStandalone || (!isMobile && !isTablet) || (platform === Platforms.android && !deferredPrompt) || platform === Platforms.other || platform === Platforms.ios) {
        return <></>;
    }
    return (
        <>
            <div className={css`display: flex;
              padding: 16px;
              background-color: rgba(255, 255, 255, 0.1);
              margin-top: auto;`}>
                <img src="./images/app-icon.png" className={css`height: 50px;
                  width: 50px;
                  margin-right: 16px;`}/>
                <div>
                    <Typography color="white" className={css`margin-top: 0;
                      margin-bottom: 16px;`}>
                        {t('installPepperMillCasinoPrompt')}
                    </Typography>
                    <Button variant="contained" color="primary" size="small"
                            onClick={handleOpen}>
                        {t('install')}
                    </Button>
                </div>
            </div>

            <BlurredBackdropModal open={open} handleClose={handleClose}
                                  dialogSx={{width: 450}}>
                <>
                    <Box sx={{
                        display: 'block',
                        width: '100%',
                        position: 'relative'
                    }}>

                        <Button onClick={() => handleClose()} sx={{position: 'absolute', top: 0, right: 0, pt: 2}}>
                            <CloseIcon
                                sx={{color: (theme) => theme.palette.text.primary, width: 24, height: 24}}/></Button>
                    </Box>

                    <img src="./images/app-icon-mock.png" className={css`margin: 48px 0`}/>
                    <div className={css`margin: 0 16px 32px`}>
                        <Typography variant="h2" textAlign="center" fontWeight="bold" className={css`
                          margin-top: 0;
                          margin-bottom: 24px;
                        `}>
                            {t('installPepperMillCasino')}
                        </Typography>
                        <Typography textAlign="center">
                            {t('installPepperMillCasinoDescription')}
                        </Typography>
                    </div>
                    {platform === Platforms.android && (
                        <div className={css`
                          display: flex;
                          justify-content: center;
                          margin-bottom: 32px;
                        `}>
                            <Button variant="contained" color="primary"
                                    onClick={handleInstall}>
                                {t('install')}
                            </Button>
                        </div>
                    )}
                    {platform === Platforms.androidFirefox && (
                        <div className={css`
                          padding: 16px;
                          background-color: #f0f0f0;
                        `}>
                            <ol className={css`margin: 0;`}>
                                <li>
                                    <div className={css`
                                      display: flex;
                                      align-items: center
                                    `}>
                                        <Typography display="inline">{t('tapOn')}</Typography>
                                        <MoreVert className={css`margin-left: 4px`} fontSize="small"/>
                                    </div>

                                </li>
                                <li>
                                    <Typography>
                                        <Trans i18nKey="selectInstall"/>
                                    </Typography>
                                </li>
                            </ol>
                        </div>
                    )}
                    {/*{platform === Platforms.ios && (*/}
                    {/*    <div className={css`*/}
                    {/*      padding: 16px;*/}
                    {/*      background-color: #f0f0f0;*/}
                    {/*    `}>*/}
                    {/*        <ol className={css`margin: 0;`}>*/}
                    {/*            <li>*/}
                    {/*                <div className={css`*/}
                    {/*                  display: flex;*/}
                    {/*                  align-items: center*/}
                    {/*                `}>*/}
                    {/*                    <Typography display="inline">{t('tapOn')}</Typography>*/}
                    {/*                    <IosShare color="info" className={css`margin-left: 8px`} fontSize="small"/>*/}
                    {/*                </div>*/}
                    {/*            </li>*/}
                    {/*            <li>*/}
                    {/*                <Typography>*/}
                    {/*                    <Trans i18nKey="selectAddToHomeScreen"/>*/}
                    {/*                </Typography>*/}
                    {/*            </li>*/}
                    {/*        </ol>*/}
                    {/*    </div>*/}
                    {/*)}*/}
                </>
            </BlurredBackdropModal>
        </>
    )
}